import Vue, { VNode } from 'vue';

export const Camera = Vue.extend({
  name: 'Camera',
  render(createElement): VNode {
    return createElement('div', {}, this.$slots.default);
  },
});
